//Components Imports
import DashboardCharts from '../../components/Dashboard/Dashboard_Charts/DashboardCharts'
import DashboardInquiry from '../../components/Dashboard/Dashboard_Inquiry/DashboardInquiry'
import Dashboard_Sidebar from '../../components/Dashboard/Dashboard_Sidebar/DashboardSidebar'
import DashboardTable from '../../components/Dashboard/Dashboard_Table/DashboardTable'
import DashboardWidgets from '../../components/Dashboard/Dashboard_Widgets/DashboardWidgets'
import Footer from '../../components/Footer/Footer'
import "./Dashboard.scss"



//Redux Imports
import {useSelector, useDispatch} from 'react-redux';
import {loadInquiries} from "../../components/Redux/Actions/inquiries"
import { getCurrentUser } from '../../components/Redux/Actions/sessions';

//React and Router-Dom Imports
import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'



function Dashboard({ handleGetOrders, handleGetProducts, handleGetOrder}) {
    const navigate = useNavigate()
    const loggedIn = useSelector(state => state.sessions.loggedIn)
    const dispatch = useDispatch()
    const requesting = useSelector(state => state.requesting);

    

    useEffect(()=> {
        dispatch(getCurrentUser())
        if(loggedIn){
            //console.log("in")
            dispatch(loadInquiries(localStorage.getItem('jwt')))
        }
        else {
            //console.log("out")
            navigate("/login")
        }
        }, [loggedIn])

    if(requesting) {
        return (<h1>Loading...</h1>)
        }

    

  return (
    <>
        <br/>
        <br/>
        <div className='home'>
            <Dashboard_Sidebar handleGetOrders={handleGetOrders} handleGetProducts={handleGetProducts}/>
                <div className='homeContainer'>

                    <div className='widgets'>
                        <DashboardWidgets type = "order_active"/>
                        <DashboardWidgets type = "order_complete"/>
                        <DashboardWidgets type = "contact"/>
                        <DashboardWidgets type = "product"/>
                    </div>

                    <div className='listContainer'>
                        <div className='listTitle'>TASKS</div>
                        <DashboardTable handleGetOrder={handleGetOrder}/>
                    </div>
    
                    <div className='charts'>
                        <DashboardInquiry />
                        <DashboardCharts title="Last 6 Months (Revenue)" aspect={2 / 1}/>
                    </div>
                </div>
        </div>
        <br/>
        <br/>
        <br/>

    </>
  )
}

export default Dashboard